import { InputMessageThreadSearch, MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { $t } from "@/lib/i18nHelpers";

export const DEFAULT_SORT: Partial<InputMessageThreadSearch> = {
  sort: "CURRENT_USER_PIN_TIME;HAS_UNREAD_MESSAGES,DESC;UPDATED_TIME,DESC",
};

export const sortImplementations: Record<string, (a: MessageThread, b: MessageThread) => number> = {
  "CURRENT_USER_PIN_TIME;HAS_UNREAD_MESSAGES,DESC;UPDATED_TIME,DESC": (a, b) => {
    if (a.pinTime === null && b.pinTime !== null) return 1;
    if (b.pinTime === null && a.pinTime !== null) return -1;
    if (a.pinTime !== b.pinTime) {
      return (a.pinTime ?? "") < (b.pinTime ?? "") ? -1 : 1;
    }

    if (!a.unreadMessageCount && b.unreadMessageCount) return 1;
    if (!b.unreadMessageCount && a.unreadMessageCount) return -1;
    if (a.unreadMessageCount !== b.unreadMessageCount) {
      return Number(Boolean(b.unreadMessageCount)) - Number(Boolean(b.unreadMessageCount));
    }

    return a.updatedTime > b.updatedTime ? -1 : 1;
  },
  "UPDATED_TIME,ASC": (a, b) => (a.updatedTime > b.updatedTime ? 1 : -1),
};

const messageThreadsSortsItems: Array<
  {
    label: string;
  } & InputMessageThreadSearch
> = [
  {
    label: $t("Unread on top"),
    ...DEFAULT_SORT,
    hidden: false,
  },
  {
    label: $t("Unread only"),
    sort: "UPDATED_TIME,ASC",
    unreadOnly: true,
    hidden: false,
  },
  {
    label: $t("Archive chats"),
    sort: "UPDATED_TIME,ASC",
    hidden: true,
  },
];
export const getMessageThreadsSortData = () => {
  const labels: string[] = [];
  const sortItems: Partial<InputMessageThreadSearch[]> = [];
  messageThreadsSortsItems.forEach(el => {
    const { label, ...sortProperties } = el;
    labels.push(label);
    sortItems.push(sortProperties);
  });
  return {
    labels,
    sortItems,
  };
};
